import { useTranslations } from "@/lib/useTranslations";
import { EditorialChecklistItems } from "@/components/ui/admin/EditorialChecklistItems";
import {
  getPlaceEditorialChecklist,
  type PlaceEditorialChecklistFields,
} from "@/core/services/types/place.types";

type PlaceEditorialChecklistProps = {
  place: PlaceEditorialChecklistFields;
};

export function PlaceEditorialChecklist({
  place,
}: PlaceEditorialChecklistProps) {
  const t = useTranslations("places.edit");
  const checklist = getPlaceEditorialChecklist(place);

  return (
    <section className="wireframe-border bg-white p-5">
      <EditorialChecklistItems
        showLabel={false}
        className="space-y-3"
        items={[
          { checked: checklist.hasCoverImage, label: t("checklistImage") },
          { checked: checklist.hasName, label: t("checklistName") },
          { checked: checklist.hasGooglePlace, label: t("checklistGoogle") },
        ]}
      />
    </section>
  );
}
